import BaseApi from './BaseApi';
import { getCookie } from '@/services/GlobalServices';
import { login as auth0Login, logout as auth0Logout, authState, initAuth, getIdToken } from '@/services/AuthService';

const URL_LOGOUT = process.env.VUE_APP_LOGOUT_URL;

// Auth0の設定が存在するか確認
const hasAuth0Config = process.env.VUE_APP_AUTH0_DOMAIN && process.env.VUE_APP_AUTH0_CLIENT_ID;

/**
 * ログイン処理
 * Auth0認証が有効な場合はAuth0のログインを使用し、
 * そうでない場合は従来のログイン処理を実行
 */
export async function login() {
  // Auth0認証が設定されている場合
  if (hasAuth0Config) {
    return await auth0Login();
  }
  
  // 従来の認証方法
  return BaseApi.post(
    '/login',
    {
      code: getCookie('code')
    }
  );
}

/**
 * ログアウト処理
 * Auth0認証が有効な場合はAuth0のログアウトを使用し、
 * そうでない場合は従来のログアウト処理を実行
 */
export async function logout() {
  // Auth0認証が設定されている場合
  if (hasAuth0Config) {
    return await auth0Logout();
  }
  
  // 従来のログアウト処理
  document.cookie = 'token=code=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  window.location.replace(URL_LOGOUT);
}

/**
 * 現在のユーザー情報を取得
 */
export function getCurrentUser() {
  return authState.user;
}

/**
 * 認証状態を確認
 */
export function isAuthenticated() {
  // Auth0認証が有効な場合
  if (hasAuth0Config) {
    return authState.isAuthenticated;
  }
  
  // 従来の認証方法（トークンの存在で判断）
  return !!getCookie('token');
}

/**
 * Auth0の初期化
 * 必要に応じて初期化を行う
 */
export async function ensureAuthInitialized() {
  if (hasAuth0Config && !authState.auth0Client) {
    await initAuth();
  }
  return true;
}

/**
 * IDトークンの取得
 * localStorageから取得するか、Auth0から取得する
 */
export async function getAuthIdToken() {
  if (hasAuth0Config) {
    return await getIdToken();
  }
  return null;
}
